import { StringOrNullOrUndefined } from 'src/app/shared/utils';

export class Signature {
  bip_id: string | null;
  analyst_1_signature?: string | null;
  analyst_2_signature?: string | null;
  physician_signature?: string | null;
  parent_guardian_signature?: string | null;
  created_at?: Date;
  updated_at?: Date;

  constructor(data: Partial<Signature> = {}) {
    this.bip_id = StringOrNullOrUndefined(data.bip_id) ?? null;
    this.analyst_1_signature = StringOrNullOrUndefined(
      data.analyst_1_signature
    ) ?? null;
    this.analyst_2_signature = StringOrNullOrUndefined(
      data.analyst_2_signature
    ) ?? null;
    this.physician_signature = StringOrNullOrUndefined(
      data.physician_signature
    ) ?? null;
    this.parent_guardian_signature = StringOrNullOrUndefined(
      data.parent_guardian_signature
    ) ?? null;
    this.created_at = data.created_at ? new Date(data.created_at) : undefined;
    this.updated_at = data.updated_at ? new Date(data.updated_at) : undefined;
  }

  static getDefault(): Signature {
    return new Signature({
      bip_id: undefined,
      analyst_1_signature: null,
      analyst_2_signature: null,
      physician_signature: null,
      parent_guardian_signature: null,
      created_at: undefined,
      updated_at: undefined,
    });
  }
}
